import React from "react";
import { ISignatureItem } from "@Models/IActivityDetails";

import "@Styles/pages/activityPage.scss";
import SignatureChart from "@Components/activity/SignatureChart";

interface IProps {
    signature?: ISignatureItem[];
}

const SignatureWidget: React.FC<IProps> = ({ signature }: IProps) => {
    return (
        <div className="newUI-glass">
            <p style={{ fontSize: "12px", color: "#1890ff", width: "100%" }}>Smoothness</p>
            <SignatureChart
                values={signature}
                lineColor={"#1890ff"}
                fill={"l(270) 0:rgba(24,144,255,0) 1:rgba(24,144,255,0.5)"}
            />
        </div>
    );
};
export default SignatureWidget;
